import React, {Component, Fragment} from 'react';
import { connect }                  from 'react-redux';
import {NavLink}                    from 'react-router-dom';

import './index.scss';

import * as routes from '../../../../constants/routes';
import * as Popups from '../../../../constants/popup-types';
import { BenefitType } from '../../../../app/enums';
import { createAnalyticsItemsList, getMediaPath } from '../../../../app/functions';
import {
    setBenefitPurchased,
    setAvailableCoupon,
    setCouponPayResult,
    acquirePaidCoupon,
} from "../../../../redux/actions";
import {setCartRequest, setCart, editItem, setOrderDone, verifyCartRequest, addPopup, doPayment} from "../../../../redux/actions";


//components
import Select from "../../../../components/forms/select";
import HtmlCheckbox from "../../../../components/forms/htmlCheckbox";

//assets
import arrow from 'assets/icons/slider-arrow-blue.svg';
import v_blue from 'assets/icons/v-blue.png';
import desktop_exit from 'assets/icons/login-x-icon.svg';
import checkedCheckboxImagePath from '../../../../assets/icons/cb_checked.svg';
import emptyCheckboxImagePath from '../../../../assets/icons/cb_empty.svg';
import Loader from "../../../../components/common/loader";
import AnalyticsManager from '../../../../app/analytics';



class PaymentPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,

            first_try: true,
            voucher_type: -1,
            num_of_vouchers: -1,
            num_of_payments: -1,

            requesting: false,
            marketingLinkClicked: false,
            marketingConsentCheckbox: false,
            showMarketingLinkNotClickedError: false,
        };
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        const available = parseInt(this.props.availableCoupon['available_coupons']) > 0;
        this.animateIn();
         this.setPageHeight();
    }

    setPageHeight(){
        if(this.props.deviceState === "mobile" || this.props.deviceState === "tablet"){
            let fullHeight = this.props.screenHeight;
            // document.getElementById("coupon-payment-popup").style.height = fullHeight + "px";
        }
    }


    componentDidUpdate(prevProps, prevState){
        if (prevProps.couponPayResult !== this.props.couponPayResult){
            this.props.setCouponPayResult(false);
            this.props.setBenefitPurchased(true);
            this.setState(({requesting:false}));
            this.animateOut();
        }

    }

    animateIn() {
        this.props.setBenefitPurchased(false);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut() {
        this.setState({animation_class: ''});
        this.props.setAvailableCoupon(false);
        this.props.handleClose();
    }

    getVoucherTypes = () =>{
        const data = this.props.availableCoupon['coupons'];

        let res = [];

        for (let key in data){
            res.push({id: key, text: data[key]['originalValue'] + ' ₪'});
            // res.push({id: key, text: data[key]['actualValue'] + ' ₪'});
        }

        return res;
    };

    getVoucherAmount = (field) =>{

        // if(this.props.availableCoupon){
            let amount = 0;

            if (field === 'available_coupons') {
                 amount = this.state.voucher_type !== -1 ? parseInt(this.props.availableCoupon.available_coupons) : 0;
            }
            else {
                amount = this.props.availableCoupon[field];
            }

            let res = [];

            for (let i = 1 ; i<= amount ; i ++){
                res.push({id: i , text: i});
            }

            return res;
        // }
    };

    voucherAmountOnSelect = (id) =>{
        this.setState({num_of_vouchers: id});
    };
    voucherTypeOnSelect = (id) =>{
        this.setState({voucher_type: id});
    };
    paymentsOnSelect = (id) =>{
        this.setState({num_of_payments: id});
    };

    getDefaultCard = () =>{
        const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        const user = this.props.user;

        const cards = user.cardsArr;

        let defaultCard = false;

        if (cards !== null) {
            for (let key in cards){
                if (cards[key].default){
                    defaultCard = cards[key];
                }
            }
        }

        let html = null;

        if (defaultCard){
            html =
                <Fragment>
                    {!isDesktop && <img src={getMediaPath(v_blue)} alt='/'/>}
                    {/*{!isDesktop && <img className='credit-company' src={getMediaPath(defaultCard.image)} alt='/'/>}*/}
                    <div className='name-wrapper'>
                        <span>{'(' + defaultCard.last_digits + ')'}</span>
                        {user.first_name + ' ' + user.last_name}
                    </div>
                </Fragment>
        }

        return html;
    };

    handleCheckboxLinkClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ showMarketingLinkNotClickedError: false, marketingLinkClicked: true });
        const url = event.currentTarget.href;
        if (url) {
            this.props.addPopup({
                type: Popups.IFRAME_POPUP,
                iframeUrl: url,
            });
        }
    };

    handlePurchasedOnClick = () =>{
        const { benefitId, benefitData, user } = this.props;

        const cards = user.cardsArr;

        let defaultCard = false;

        if (cards !== null) {
            for (let key in cards){
                if (cards[key].default){
                    defaultCard = cards[key];
                }
            }
        }



        if (this.state.num_of_payments === -1 || this.state.voucher_type === -1 || this.state.num_of_vouchers === -1 || !defaultCard){
            this.setState({ first_try:false });
        } else {
            const [, , actualPrice] = this.calculatePrices();

            this.props.addPopup({
                type: Popups.PURCHASE_APPROVAL,
                action: () => this.handleDoPayment(defaultCard,benefitId,actualPrice,benefitData),
                price: actualPrice,
                phone: this.props.user.phone,
            });
        }
    };

    handleDoPayment(defaultCard,benefitId,actualPrice,benefitData){
        this.setState({ requesting: true });

        const onPurchaseResponse = (response) => {
            const transactionId = `${benefitId}-${response?.order_id}`;

            AnalyticsManager.logPurchase(createAnalyticsItemsList([
                { ...benefitData, quantity: this.state.num_of_vouchers },
            ]), actualPrice, transactionId);

            AnalyticsManager.logBenefitPaidCouponSuccess(benefitId, actualPrice);
        };

        const onAnyResponse = () => this.setState({ requesting: false });

        const payload = {
            actualPrice: actualPrice,
            couponValue: this.state.voucher_type,
            paymentsNum: this.state.num_of_payments,
            couponNum:   this.state.num_of_vouchers,
            benefitId:   benefitId,
            tokenId:     defaultCard.id,
        };
        const showMarketingCheckbox = (this.props.benefitType == BenefitType.PAID_COUPON || this.props.benefitType == BenefitType.PURCHASE_VOUCHER) && !this.props.user?.maStatus;
        if (showMarketingCheckbox) {
            payload.marketingCheckbox = this.state.marketingConsentCheckbox;
        }

        this.props.acquirePaidCoupon(payload, onPurchaseResponse, onAnyResponse, this.props.benefitData, this.props.text, this.props.handleClose);
    }


    isCashBack() {
        const trade_charge_type = this.props.availableCoupon.trade_charge_type;// from getDetailedBenefitByIdForWeb
        const tradeBenefitsChargeTypes = this.props.TradeBenefitsChargeTypes;// from generalDeclaration

        return tradeBenefitsChargeTypes[trade_charge_type] === "cashback"

    }

    displayNumOfVouchers(){
        if(this.state.voucher_type===-1){
            return 0;
        } else if(this.state.num_of_vouchers > 0){
            return this.state.num_of_vouchers;
        } else{
            return 1;
        }
    }

    calculatePrices() {
        const { availableCoupon } = this.props;
        const { voucher_type: voucherType, num_of_vouchers: numOfVouchers } = this.state;

        let discount = 0,
            originalPrice = 0,
            actualPrice = 0;

        if (availableCoupon && voucherType !== -1) {
            originalPrice = voucherType;
            actualPrice = availableCoupon?.coupons?.[voucherType]?.actualValue;

            if (numOfVouchers > 0) {
                let calcDiscount = (originalPrice * 100) - (actualPrice * 100);
                discount = numOfVouchers * (calcDiscount / 100);
                actualPrice = numOfVouchers * availableCoupon?.coupons?.[voucherType]?.actualValue;
            } else {
                let calcDiscount = (originalPrice * 100) - (actualPrice * 100);
                discount = calcDiscount / 100;
            }
        }

        discount = this.formatNumber(discount);
        originalPrice = this.formatNumber(originalPrice);
        actualPrice = this.formatNumber(actualPrice);

        return [discount, originalPrice, actualPrice];
    }

    formatNumber(number) {
        return Number(number).toFixed(2);
    }

    render() {
        const { deviceState, text, user, benefitType } = this.props;

        const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';
        const showMarketingCheckbox = (benefitType == BenefitType.PAID_COUPON || benefitType == BenefitType.PURCHASE_VOUCHER) && !user?.maStatus;

        const [discount, original_price, actual_price] = this.calculatePrices();

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() } >
                <div className = {"popup_wrapper payment-popup " + this.state.animation_class} id="coupon-payment-popup" onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">

                        <div className='top-wrapper'>
                            <div className='top'>
                                <div className='head'>
                                    <img className='exit' src={isDesktop ? getMediaPath(desktop_exit) : getMediaPath(arrow)} alt='/' onClick={() => this.animateOut()}/>
                                    <span>{this.props.availableCoupon.form_title}</span>
                                </div>
                                <form id='payment-details-form'>
                                    <div className='form-head'>
                                        <span>{text['payment_popup_details_title']}</span>
                                    </div>

                                    <Select placeholder = {text['payment_popup_details_typr']}
                                            options={this.getVoucherTypes()}
                                            deviceState='desktop'
                                            arrow={getMediaPath(arrow)}
                                            className='vou-type'
                                            onChange={this.voucherTypeOnSelect}/>
                                    <div className={'amount-wrapper'}>
                                    <Select placeholder = {text['payment_popup_details_voucher_amount']}
                                            options={this.getVoucherAmount('available_coupons')}
                                            deviceState='desktop'
                                            arrow={getMediaPath(arrow)}
                                            className='vou-amount'
                                            onChange={this.voucherAmountOnSelect}
                                            disabled={this.state.voucher_type === -1}
                                    />
                                    <span className="limits-text">{this.props.availableCoupon.limits_text}</span>
                                    </div>
                                    <Select placeholder = {text['payment_popup_details_payment_amount']}
                                            options={this.getVoucherAmount('max_payments')}
                                            deviceState='desktop'
                                            arrow={getMediaPath(arrow)}
                                            onChange={this.paymentsOnSelect}/>

                                    <span className='payment-method-span'>{text['payment_popup_payment_method']}</span>

                                    <div className='card-wrapper'>
                                        {this.getDefaultCard()}
                                    </div>

                                    <NavLink to={routes.personal_zone + '/אמצעי_תשלום'} className='payment-method-change' onClick={() =>this.animateOut()}>{text['payment_popup_payment_method_change']}</NavLink>
                                </form>

                            </div>

                        </div>



                        <div className='bottom-wrapper'>
                            <div className='bottom'>
                                <div className='price-container'>
                                    <div className='price-wrap'>
                                        <span className='text'>{text['payment_popup_full_price']}</span>
                                        <span className='value'>&#8362;{ original_price}</span>
                                    </div>
                                    <div className='price-wrap'>
                                        <span className='text'>{text['payment_popup_number_of_vouchers']}</span>
                                        <span className='value'>{this.displayNumOfVouchers()}</span>
                                    </div>

                                    {!this.isCashBack() &&
                                        <Fragment>
                                            <div className='price-wrap'>
                                                <span className='text'>{text["payment_popup_total"]}</span>
                                                <span className='value'>
                                                    &#8362;{this.formatNumber(
                                                        this.state.num_of_vouchers === -1
                                                            ? original_price
                                                            : this.state.num_of_vouchers * original_price
                                                    )}
                                                </span>
                                            </div>

                                            <div className='not-cashback-price-wrap'>
                                                <span className='not-cashback-text'>{text['payment_popup_final_credit_card_charge']}</span>
                                            </div>

                                        </Fragment>
                                    }

                                    {this.isCashBack() &&
                                        <Fragment>
                                            <div className='price-wrap'>
                                                <span className='text'>{text['payment_popup_final_credit_card_charge']}</span>
                                                <span className='value'>
                                                    &#8362;{this.formatNumber(
                                                        this.state.num_of_vouchers === -1
                                                            ? original_price
                                                            : this.state.num_of_vouchers * original_price
                                                    )}
                                                </span>
                                            </div>

                                            <div className="cash-back-wrapper">
                                                <p className="cash-back-text">{this.props.availableCoupon.cashback_description}</p>
                                            </div>

                                        </Fragment>
                                    }



                                    <div className='price-wrap'>
                                        <span className='final-price'>&#8362;{actual_price}</span>
                                    </div>

                                    { discount > 0 &&
                                        <div className='discount-price-wrap'>
                                            <span className='discount-text'>{text['payment_popup_discount']}</span>
                                            <span className='discount-value'>&#8362;{discount}</span>
                                        </div>
                                    }



                                </div>

                                {showMarketingCheckbox && (
                                    <div className="payment-popup-marketing-checkbox">
                                        <HtmlCheckbox
                                            name="marketing-consent"
                                            html={text['consents_marketing_checkbox_html']}
                                            value={this.state.marketingConsentCheckbox}
                                            onChange={(checked) => this.setState({ marketingConsentCheckbox: checked })}
                                            handleLinkClick={this.handleCheckboxLinkClick}
                                            disableCheckbox={!this.state.marketingLinkClicked}
                                            onDisabledClicked={() => this.setState({ showMarketingLinkNotClickedError: true })}
                                            checked_img={checkedCheckboxImagePath}
                                            not_checked_img={emptyCheckboxImagePath}
                                            className="payment-popup-cb"
                                        />
                                        {this.state.showMarketingLinkNotClickedError && (
                                            <p className="payment-popup-checkbox-error">
                                                {text['agreement_link_not_clicked_error']}
                                            </p>
                                        )}
                                    </div>
                                )}

                                <div className='submit-wrapper'>
                                    <button className='submit-btn' onClick={this.handlePurchasedOnClick}>{text['payment_popup_submit_text']}</button>
                                </div>
                            </div>

                        </div>

                    </div>

                    {this.state.requesting && (
                      <Loader className="payment-popup-loader"/>
                    )}
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        user: store.config.UserData,
        availableCoupon: store.data.AvailableCoupon,
        couponPayResult: store.data.PayCouponResult,
        TradeBenefitsChargeTypes: store.config.TradeBenefitsChargeTypes,
        benefitData: store.data.LastBenefitPage,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        setBenefitPurchased: (payload) => dispatch(setBenefitPurchased(payload)),
        setAvailableCoupon: (payload) => dispatch(setAvailableCoupon(payload)),
        acquirePaidCoupon: (payload, onPurchaseResponse, onAnyResponse) => dispatch(
          acquirePaidCoupon(payload, onPurchaseResponse, onAnyResponse)
        ),
        setCouponPayResult: (payload) => dispatch(setCouponPayResult(payload)),
        addPopup: (payload) => dispatch(addPopup(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PaymentPopup);
